"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var controller_1 = require("./controller");
var view_1 = require("./view");
var ImagePlugin = /** @class */ (function (_super) {
    __extends(ImagePlugin, _super);
    function ImagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'image';
        _this.Controller = controller_1.ImageController;
        _this.Schema = view_1.ImageView;
        return _this;
    }
    return ImagePlugin;
}(core_utilities_1.SylPlugin));
exports.ImagePlugin = ImagePlugin;
var InlineImagePlugin = /** @class */ (function (_super) {
    __extends(InlineImagePlugin, _super);
    function InlineImagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Schema = view_1.InlineImageView;
        return _this;
    }
    return InlineImagePlugin;
}(ImagePlugin));
exports.InlineImagePlugin = InlineImagePlugin;
//# sourceMappingURL=index.js.map